import { render, staticRenderFns } from "./currency-rate-item.vue?vue&type=template&id=6d845d70"
import script from "./currency-rate-item.vue?vue&type=script&lang=ts"
export * from "./currency-rate-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports